import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Bloglist1 from "@/../../public/images/blogList-1.jpg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { blogListApi } from "../service/apis/bloglisting.api"; 
import Loader from "../common/Loader/loader";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomPagination from "../component/custom-pagination";

const BlogListScreen = () => {
    const navigate = useNavigate();

    const [responseData, setResponseData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [isLoading, setIsLoading] = useState(false);

    const blogLists = async(pagee: number) => {
        setIsLoading(true);
        try {
            const response = await blogListApi(pagee);
            //console.log(response);
            setResponseData(response.blogData.Blogs);
            setCurrentPage(response.blogData.page);
            setTotalPages(response.blogData.totalPages); 
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        blogLists(currentPage);
    }, [currentPage]);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    // const decodeHtml = (html = "") => {
    //     const txt = document.createElement("textarea");
    //     txt.innerHTML = html;
    //     return txt.value;
    // };

    // const sanitizeData = (htmldata = "") => {
    //     const sanitizedDescription = decodeHtml(htmldata);
    //     return (
    //         <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
    //     );
    // };

    // const trimWords = (content: any, wordLimit = 12) => {
    //     const contentString = String(content);
    //     const words = contentString.split(/\s+/);
    //     if (words.length > wordLimit) {
    //         return words.slice(0, wordLimit).join(' ') + ' ...';
    //     }
    //     return contentString;
    // }

    return (
        <>
            {/* <HeaderScreen /> */}
            <div className="front-pages">
                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    <h1>Blog</h1>
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" /> Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>Blog</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {isLoading ? (
                    <Loader />
                ) : (
                    <section className="bloglist-area position-relative common-padd-xl pt-0">
                        <div className="container">
                            <div className="row">
                                {responseData ? (
                                    responseData.map((blog: any) => (
                                    <div className="col-lg-4" key={blog._id}>
                                        <div className="blogcard-holder">
                                            <div className="blogImg">
                                                <Link to={`/blog-details/${blog.slug}`}>
                                                    <img src={blog.featuredImage} alt={blog.title} />
                                                </Link>

                                                <Link to={`/blog-details/${blog.slug}`}>
                                                    {blog.featuredImage ? (
                                                        <img src={blog.featuredImage} alt={blog.title} />
                                                    ) : (
                                                        <img src={Bloglist1} alt="blog" />
                                                    )}
                                                </Link>
                                            </div>
                                            <div className="blogInfo">
                                                <h3>
                                                    <Link to={`/blog-details/${blog.slug}`}>{blog.title}</Link>
                                                </h3>
                                                {/* {sanitizeData(trimWords(blog.content))} */}
                                                <p>{blog.excerpt}</p>
                                                {/* <a href="javascript:void(0)" onClick={() => navigate(`/blog-details/${blog._id}`)} className="readmore">Read More</a> */}
                                                <Link to={`/blog-details/${blog.slug}`} className="readmore">Read More</Link>
                                            </div>
                                        </div>
                                    </div>
                                    ))
                                ) : (
                                    <Loader />
                                )}

                            </div>
                            <div className="row">
                                <div className="col-lg-12 paginationholder">
                                    {/* <Pagination>
                                        <Pagination.Prev />
                                        <Pagination.Item>{1}</Pagination.Item>
                                        <Pagination.Item active>{2}</Pagination.Item>
                                        <Pagination.Item>{3}</Pagination.Item>
                                        <Pagination.Ellipsis />
                                        <Pagination.Item>{6}</Pagination.Item>
                                        <Pagination.Next />
                                    </Pagination> */}

                                    <CustomPagination
                                        totalPages={totalPages}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    />

                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>
            {/* <FooterScreen /> */}
        </>
    )
}
export default BlogListScreen;